import * as React from "react";
import { Admin, Resource } from 'react-admin';
import { Route } from 'react-router-dom';
import jsonServerProvider from 'ra-data-json-server';
import { UserList, UserEdit, UserShow, UserCreate } from './components/users/UserList';
import { TransactionList, TransactionCreate, TransactionShow } from './components/transactions/transactions';
import { MachineList, MachineShow, MachineCreate, MachineEdit } from './components/machines/machines';
import { BuildingList, BuildingShow, BuildingCreate, BuildingEdit } from './components/buildings/buildings';
import { InternetList } from './components/internet/internet';
import { IntentsList } from './components/intents/intents';
// import InternetByBuildingList from './components/internet/internet';
import PostIcon from '@material-ui/icons/Book';
import UserIcon from '@material-ui/icons/Group';
import ApartmentIcon from '@material-ui/icons/Apartment';
import LocalLaundryServiceIcon from '@material-ui/icons/LocalLaundryService';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import Dashboard from './components/dashboard/Dashboard'
import authProvider from './components/providers/authProvider';
import { cacheDataProviderProxy } from 'react-admin';
import Challenge from './components/users/challenge.jsx';
import ReportMachines from "./components/reports/reportMachines";
import reportMachinesByTime from "./components/reports/reportMachinesByTime";
import MyLayout from "./components/layout/Layout";
import fetchJson from './dataprovider';
import { UsersBuildingsCreate, UsersBuildingsList } from "./components/users_buildings/users_buildings";
import { CostCenterList, CostCenterShow, CostCenterCreate, CostCenterEdit } from './components/cost_centers/cost_centers';
import { MachineTypeCreate, MachineTypeList, MachineTypeEdit } from "./components/machine_types/machine_types";
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import { PriceCreate, PriceEdit, PriceShow } from "./components/prices/prices";
import PermScanWifiIcon from '@material-ui/icons/PermScanWifi';
import { PersonalCreate, PersonalEdit, PersonalList, PersonalShow } from "./components/personal/personal";
import { MessagesCreate, MessagesEdit, MessagesList, MessagesShow } from "./components/messages/messages";
import { RolesList, RolesShow, RolesCreate } from "./components/roles/roles";
import { DisconnectionList } from "./components/disconnections/disconnections";

const config = require('./config.json')

// import myRestProvider from './components/myRestProvider'


const url = config.API_URL;

const dataProvider = cacheDataProviderProxy(jsonServerProvider(url, fetchJson));

function App() {
  // let permissions;
  // try {
  // if (localStorage.getItem("token") == null) {
  // throw Error;
  // }
  // } catch (e) {
  // }
  // let i = 0;
  // while (permissions == null && i < 10) {
  // permissions = localStorage.getItem('permissions');
  // authProvider.getPermissions().then(data => {
  // permissions = data;
  // console.log("permiso", data);
  // }).catch(err => {
  // });

  return (
    <Admin dashboard={Dashboard} authProvider={authProvider} dataProvider={dataProvider} customRoutes={[
      <Route exact path="/challenge" render={(routeProps) => <Challenge resource="sessions/admin/challenge" basePath={routeProps.match.url} {...routeProps} />} noLayout />,
      <Route exact path="/report-machines" component={ReportMachines} />,
      <Route exact path="/report-machines-time" component={reportMachinesByTime} />,
    ]}
      layout={MyLayout}
      requireAuth
    >
      {(permissions) => {
        return [
          (permissions.includes("users.list")) &&
          <Resource name="users" options={{ label: 'Usuarios' }} icon={UserIcon}
            show={permissions.includes("users.show") ? UserShow : null}
            list={permissions.includes("users.list") && UserList}
            edit={permissions.includes("users.edit") && UserEdit}
            create={permissions.includes("users.create") && UserCreate}
          />,

          (permissions.includes("transactions.list")) &&
          <Resource name="transactions" options={{ label: 'Transacciones' }} icon={PostIcon}
            show={permissions.includes("transactions.show") && TransactionShow}
            list={permissions.includes("transactions.list") && TransactionList}
            create={permissions.includes("transactions.create") && TransactionCreate}
          />,

          (permissions.includes("buildings.list")) &&
          <Resource name="buildings" options={{ label: 'Edificios' }} icon={ApartmentIcon}
            list={permissions.includes("buildings.list") && BuildingList}
            show={permissions.includes("buildings.show") && BuildingShow}
            create={permissions.includes("buildings.create") && BuildingCreate}
            edit={permissions.includes("buildings.edit") && BuildingEdit}
          />,

          (permissions.includes("machines.list")) &&
          <Resource name="machines" options={{ label: 'Máquinas' }} icon={LocalLaundryServiceIcon}
            show={permissions.includes("machines.show") && MachineShow}
            list={permissions.includes("machines.list") && MachineList}
            create={permissions.includes("machines.create") && MachineCreate}
            edit={permissions.includes("machines.edit") && MachineEdit}
          />,

          (permissions.includes("users_buildings.list")) &&
          <Resource name="users-buildings" options={{ label: 'Usuarios/Edificios' }} icon={AssignmentIndIcon}
            list={permissions.includes("users_buildings.list") && UsersBuildingsList}
            create={permissions.includes("users_buildings.create") && UsersBuildingsCreate}
          />,

          (permissions.includes("cost_centers.list")) &&
          <Resource name="cost_centers" options={{ label: 'Precios' }} icon={MonetizationOnIcon}
            list={permissions.includes("cost_centers.list") && CostCenterList}
            show={permissions.includes("cost_centers.show") && CostCenterShow}
            create={permissions.includes("cost_centers.create") && CostCenterCreate}
            edit={permissions.includes("cost_centers.edit") && CostCenterEdit}
          />,

          (permissions.includes("internet.list")) &&
          <Resource name="stats/internet-buildings" options={{ label: 'Internet' }} icon={PermScanWifiIcon}
            list={permissions.includes("internet.list") && InternetList}
          />,

          (permissions.includes("disconnections.list")) &&
          <Resource name="disconnections" options={{ label: 'Desconexiones' }} icon={PermScanWifiIcon}
            list={permissions.includes("disconnections.list") && DisconnectionList}
          />,

          (permissions.includes("machine_types.list")) &&
          <Resource name="machine_types" options={{ label: 'Tipos de máquinas' }} icon={LocalLaundryServiceIcon}
            list={permissions.includes("machine_types.list") && MachineTypeList}
            create={permissions.includes("machine_types.create") && MachineTypeCreate}
            edit={permissions.includes("machine_types.edit") && MachineTypeEdit}
          />,

          (permissions.includes("prices.list")) &&
          <Resource name="prices" options={{ label: 'Precios' }} icon={AssignmentIndIcon}
            create={permissions.includes("prices.create") && PriceCreate}
            edit={permissions.includes("prices.edit") && PriceEdit}
            show={permissions.includes("prices.show") && PriceShow}
          />,

          (permissions.includes("personal.list")) &&
          <Resource name="staff" options={{ label: 'Personal' }} icon={UserIcon}
            show={permissions.includes("personal.show") && PersonalShow}
            list={permissions.includes("personal.list") && PersonalList}
            edit={permissions.includes("personal.edit") && PersonalEdit}
            create={permissions.includes("personal.create") && PersonalCreate}
          />,

          (permissions.includes("roles.list")) &&
          <Resource name="roles" options={{ label: 'Roles' }} icon={AssignmentIndIcon}
            show={permissions.includes("roles.show") && RolesShow}
            list={permissions.includes("roles.list") && RolesList}
            create={permissions.includes("roles.create") && RolesCreate}
          />,

          (permissions.includes("messages.list")) &&
          <Resource name="messages" options={{ label: 'Mensajes de app' }} icon={UserIcon}
            show={permissions.includes("messages.show") && MessagesShow}
            list={permissions.includes("messages.list") && MessagesList}
            edit={permissions.includes("messages.edit") && MessagesEdit}
            create={permissions.includes("messages.create") && MessagesCreate}
          />,

          (permissions.includes("intents.list")) &&
          <Resource name="intents" options={{ label: 'Intentos' }} icon={PostIcon}
            list={permissions.includes("intents.list") && IntentsList}
          />,

        ];
      }}
    </Admin>
  )
};


export default App;
